export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden pt-[72px]">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute -bottom-60 -left-40 w-[500px] h-[500px] rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="section-container relative z-10 w-full">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-4">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                <i className="ri-movie-2-line mr-1"></i>蓝光画质
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-800 whitespace-nowrap">
                <i className="ri-stack-line mr-1"></i>海量片源
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 whitespace-nowrap">
                <i className="ri-speed-up-line mr-1"></i>极速播放
              </span>
            </div>

            <h1 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              91影视看片app
              <span className="block text-primary-600 mt-1 text-xl sm:text-2xl md:text-3xl lg:text-4xl">
                高清影视在线观看平台
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 font-light mb-3 leading-relaxed">
              片源清晰度领先，播放流畅不缓冲，满足你对画质的所有要求
            </p>

            <p className="text-sm md:text-base text-foreground-500 mb-6 leading-relaxed max-w-xl mx-auto lg:mx-0">
              91影视看片app汇聚高清电影在线观看、蓝光影视资源、高清电视剧免费全集和超清综艺播放内容。
              每日更新最新院线大片与经典佳片，覆盖动作、科幻、爱情、悬疑、喜剧等全品类题材，
              一站式满足影视爱好者的观影需求。当前热播专题聚焦暑期档重磅回归与年度高分神作盘点，
              是你不可错过的高清影视大全入口。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 sm:gap-6 mb-6">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-600">10万+</div>
                <div className="text-xs text-foreground-500">高清片源覆盖</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-600">4K蓝光</div>
                <div className="text-xs text-foreground-500">顶级画质标准</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-secondary-600">极速加载</div>
                <div className="text-xs text-foreground-500">零缓冲播放体验</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                onClick={(e) => handleScroll(e, '#app')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer shadow-sm"
              >
                <i className="ri-download-2-line"></i>立即下载APP
              </a>
              <a
                href="#features"
                onClick={(e) => handleScroll(e, '#features')}
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line"></i>了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg xl:max-w-xl">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20with%20warm%20golden%20spotlight%20on%20dark%20background%2C%20elegant%20movie%20poster%20composition%20with%20dramatic%20lighting%2C%20classic%20cinema%20atmosphere%2C%20vintage%20film%20texture%2C%20artistic%20and%20sophisticated%20style%2C%20rich%20contrast%20between%20warm%20golden%20tones%20and%20deep%20shadows%2C%20theatrical%20mood&width=800&height=600&seq=hero-main-visual-2026&orientation=landscape"
                alt="91影视看片app - 高清影视在线观看平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-600/10 via-transparent to-accent-500/15"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}